module.exports = __webpack_public_path__ + "img/help_dataset_marker2.694b7b2c.png";